import { AppText } from "@/components/Text/AppText";
import { Resume } from "@/types/resume";
import { IUserJob } from "@/types/userJob";

interface SmartMatchSummaryProps {
    selectedResume?: Resume;
    userJob?: IUserJob;
}

export const SmartMatchSummary = ({
    selectedResume,
    userJob,
}: SmartMatchSummaryProps) => {
    if (!selectedResume || !userJob) return null;

    return (
        <div className="mx-auto w-full max-w-[500px] px-2">
            <div className="rounded-lg bg-white p-4 shadow-sm ring-2 ring-neutral-300">
                <div className="space-y-3">
                    <div>
                        <AppText
                            variant="contextheading"
                            className="text-neutral-900"
                        >
                            Resume:
                        </AppText>
                        <AppText
                            variant="regular"
                            className="text-neutral-700"
                        >
                            {selectedResume?.name || "No resume selected"}
                        </AppText>
                    </div>

                    <div>
                        <AppText
                            variant="contextheading"
                            className="text-neutral-900"
                        >
                            Job:
                        </AppText>
                        <AppText
                            variant="regular"
                            className="text-neutral-700"
                        >
                            {userJob?.jobTitle || "No title available"} -{" "}
                            {userJob?.companyName || "-"}
                        </AppText>
                    </div>
                </div>
            </div>
        </div>
    );
};
